import { generatePath, matchPath } from "react-router";

const oldToNewMap = [
    // Behind PAYMENT_LOGS_FEATURE_FLAG
    ["/payment-log", "/settings/payment-log"],
    // Behind TARIFF_FEATURE_FLAG
    ["/tariffs", "/settings/tariffs"],
    [
        "/tariffs/:pricingScheduleId/:pricingScheduleGroupId",
        "/settings/tariffs/:pricingScheduleId/:pricingScheduleGroupId",
    ],
    ["/tariffs/create", "/settings/tariffs/create"],
    [
        "/tariffs/edit/:pricingScheduleId/:pricingScheduleGroupId",
        "/settings/tariffs/edit/:pricingScheduleId/:pricingScheduleGroupId",
    ],
].toSorted(
    // Sort by longest number of segments to match the most specific path first
    ([fromA], [fromB]) =>
        fromB.split("/").length - fromA.split("/").length ||
        fromB.length - fromA.length,
);

export const getUpdatedPath = (url: string): string | undefined => {
    if (url === "/") {
        return undefined;
    }

    // Check the old routes mapping
    const newPath = oldToNewMap.reduce(
        (finalPath, [oldPath, newPath]) => {
            if (finalPath) return finalPath;
            const routeMatch = matchPath({ path: oldPath, end: true }, url);
            if (routeMatch) {
                return generatePath(newPath, routeMatch.params);
            } else {
                return null;
            }
        },
        null as string | null,
    );
    return newPath ?? undefined;
};
